import {
  defaultCellRenderer,
  defaultCellRenderer as renderer,
  defaultGroupRenderer as groupRenderer,
  generateMultiFilterConfigFromModel, linkifyText
} from "../../utils/utils.jsx";
import { WIDGET_KEYS } from "../WidgetKeys.jsx";
import { customGroupByOrder } from "../../utils/otherUtils.jsx";
import { Resource } from "../../../bryntum-lib/models/Resource";

export const RESOURCE_VIEW_COLUMNS = [
  {
    id: "plan-resource-icon",
    type: WIDGET_KEYS.columnResourceTagIcon,
    field: "iconValue",
    region: "locked",
    align: "center",
    flex: 1,
    editor: false,
    // do not override groupRenderer as the widget has its own implementation
  },
  {
    id: "plan-resource-blackout",
    type: WIDGET_KEYS.columnResourceBlackout,
    hidden: true,
  },
  {
    id: "plan-resources-icon-label",
    type: WIDGET_KEYS.columnEntityMainName,
    text: "Resource ID",
    region: "locked",
    field: "name",
    align: 'left',
    flex: 1,
    groupRenderer,
    headerMenuItems: {
      addNewEntity: {
        _menuId: "resource",
        icon: "fa-plus",
        text: "New Resource",
        weight: 10
      }
    },
  },
  {
    id: "plan-resource-contacts",
    type: WIDGET_KEYS.contactColumn
  },
  {
    id: "plan-resource-reminder-bell",
    type: WIDGET_KEYS.alertBellColumn,
    isAlertBell: true,
  },
  { id: "plan-resource-notes", type: WIDGET_KEYS.notesColumn },
  { id: "plan-resource-media", type: WIDGET_KEYS.mediaColumn },
  { id: "plan-resource-documents", type: WIDGET_KEYS.documentsColumn },
  {
    id: "plan-resource-description",
    text: "Description",
    field: "description",
    flex: 1,
    type: WIDGET_KEYS.swivuSortColumn,
    cellCls: "!overflow-hidden",
    renderer: ({ record }) => linkifyText(defaultCellRenderer({ value: record.description })),
    groupRenderer
  },
  {
    id: "plan-resource-assigned-to",
    editor: false,
    swivuListTitle: "Resource Assigned To",
    type: WIDGET_KEYS.assignToColumn,
    onSwivuEditMessage: "onClickSwivuUserEditMessage",
  },
  {
    id: "plan-resource-eligible-users-v1",
    editor: false,
    swivuListTitle: "Resource Eligible Users",
    type: WIDGET_KEYS.eligibleUserColumn,
    onSwivuEditMessage: "onClickSwivuUserEditMessage",
    hidden: true
  },
  {
    id: "plan-resource-type",
    editor: false,
    swivuListTitle: "Resource Type",
    type: WIDGET_KEYS.columnResourceType,
    headerMenuItems: {
      columnItem: customGroupByOrder("teamId", "teamStore")
    }
  },
  { id: "resource-checklist", type: WIDGET_KEYS.checklistColumn },
  {
    id: "plan-resource-team",
    ref: "team",
    text: "Team",
    field: "teamValue",
    type: WIDGET_KEYS.teamField,
    swivuListTitle: "Resource Team",
    editor: false,
    flex: 1,
    headerMenuItems: {
      columnItem: customGroupByOrder("teamId", "teamStore")
    }
  },
  {
    id: "plan-resource-aging",
    text: "Age",
    field: "aging",
    flex: 1,
    type: "agingColumn",
    editor: false
  },

  {
    id: "plan-resource-job",
    text: "Sub Type",
    field: "jobTitle",
    type: WIDGET_KEYS.swivuSortColumn,
    flex: 1,
    renderer,
    groupRenderer
  },
  {
    id: "plan-resource-status",
    text: "Status",
    editor: false,
    type: WIDGET_KEYS.columnResourceStatus,
    field: "statusValue",
    flex: 1,
    headerMenuItems: {
      columnItem: customGroupByOrder("statusId", "tagStore")
    }
  },
  {
    id: "plan-resource-category",
    text: "Category",
    editor: false,
    type: WIDGET_KEYS.columnResourceCategory,
    field: "categoryValue",
    flex: 1,
    headerMenuItems: {
      columnItem: customGroupByOrder("categoryId", "tagStore")
    }
  },
  {
    id: "plan-resource-tag",
    text: "Tags",
    editor: false,
    type: WIDGET_KEYS.columnResourceTag,
    field: "tagsValue",
    flex: 1,
  },
  {
    id: "plan-resource-location",
    text: "Location",
    field: "location",
    flex: 1,
    type: WIDGET_KEYS.swivuSortColumn,
    renderer,
    groupRenderer
  }
];

export const RESOURCE_VIEW_FILTER_FIELD_CONFIG = {
  ...generateMultiFilterConfigFromModel(Resource),
  assignedBoardUserValues: { type: '_swivu_settings' },
  eligibleUserValues: { type: '_swivu_settings' },
  tagsValue: { type: '_swivu_settings' },
  categoryValue: { type: '_swivu_settings' },
  statusValue: { type: '_swivu_settings' },
  teamValue: { type: '_swivu_settings' },
  typeValue: { type: '_swivu_settings' }
};
